/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9c5a7c5f (Mon Apr 13 19:32:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface AgreementWebhookRequestBodyAgreementDocumentsInfoSignedDocumentInfo
 */
export interface AgreementWebhookRequestBodyAgreementDocumentsInfoSignedDocumentInfo {
  /**
   *
   * @type string
   * @memberof AgreementWebhookRequestBodyAgreementDocumentsInfoSignedDocumentInfo
   */
  document?: string
}

export function AgreementWebhookRequestBodyAgreementDocumentsInfoSignedDocumentInfoFromJSON(
  json: any
): AgreementWebhookRequestBodyAgreementDocumentsInfoSignedDocumentInfo {
  return AgreementWebhookRequestBodyAgreementDocumentsInfoSignedDocumentInfoFromJSONTyped(
    json,
    false
  )
}

export function AgreementWebhookRequestBodyAgreementDocumentsInfoSignedDocumentInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AgreementWebhookRequestBodyAgreementDocumentsInfoSignedDocumentInfo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    document: !exists(json, 'document') ? undefined : json['document'],
  }
}

export function AgreementWebhookRequestBodyAgreementDocumentsInfoSignedDocumentInfoToJSON(
  value?: AgreementWebhookRequestBodyAgreementDocumentsInfoSignedDocumentInfo | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    document: value.document,
  }
}
